import { useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  isAppHost,
  isMarketingHost,
  isAppPath,
  isMarketingPath,
  isLocalhost,
  appUrl,
  marketingUrl,
} from '../lib/domains';

/**
 * Enforces the marketing/app domain split.
 *
 * If the current path doesn't belong on the current host, hard-redirect to the
 * correct host with path/query/hash preserved. Skipped entirely on localhost.
 */
export default function DomainGuard({ children }: { children: React.ReactNode }) {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (isLocalhost()) return;

    const onMarketing = isMarketingHost();
    const onApp = isAppHost();

    if (onMarketing && isAppPath(pathname)) {
      window.location.replace(appUrl(pathname, search, hash));
      return;
    }

    if (onApp && pathname === '/') {
      window.location.replace(marketingUrl('/', search, hash));
      return;
    }

    if (onApp && isMarketingPath(pathname) && pathname !== '/') {
      window.location.replace(marketingUrl(pathname, search, hash));
      return;
    }
  }, [pathname, search, hash]);

  return <>{children}</>;
}
